<template>
  <div class="box-wrap wrap-view">
    <div class="box-wrap__header box-header">
      <div v-if="$slots.header||$slots['header-center']" class="box-header__left">
        <slot name="header"></slot>
      </div>
      <div v-if="$slots['header-center']" class="box-header__center">
        <slot name="header-center"></slot>
      </div>
      <div v-if="$slots.tools||$slots['header-center']" class="box-header__right">
        <slot name="tools"></slot>
      </div>
    </div>
    <div class="box-content" :class="contentClass" :style="contentStyle">
      <slot></slot>
    </div>
    <div v-if="$slots.footer||$slots['footer-center']||$slots['footer-right']" class="box-wrap__footer box-header">
      <div v-if="$slots.footer||$slots['footer-center']" class="box-header__left">
        <slot name="footer"></slot>
      </div>
      <div v-if="$slots['footer-center']" class="box-header__center">
        <slot name="footer-center"></slot>
      </div>
      <div v-if="$slots['footer-right']||$slots['footer-center']" class="box-header__right">
        <slot name="footer-right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'box',
    props: {
      loading: {type: Boolean, default: false}, //v-loading="loading"
      contentStyle: {type: Object, default: () => ({})},
      contentClass: {type: Object, default: () => ({})}
    }
  }
</script>
